
import { Building, Users } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const TargetAudience = () => {
  const isMobile = useIsMobile();
  
  return (
    <section id="malgrupper" className="py-16 sm:py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-16 md:px-8 md:py-24">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-storystore-blue mb-3 sm:mb-4">Vem vi hjälper</h2>
          <p className="text-base sm:text-xl text-gray-600 mb-8 sm:mb-12 max-w-3xl mx-auto">
            Vi är specialister på att hjälpa två typer av klienter att växa sin digitala närvaro
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-5xl mx-auto">
          {/* Företag */}
          <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8 transform transition-all duration-300 hover:scale-105">
            <div className="bg-storystore-blue/10 w-16 sm:w-20 h-16 sm:h-20 rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto">
              <Building size={isMobile ? 32 : 40} className="text-storystore-blue" />
            </div>
            
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-center text-storystore-blue">Företag</h3>
            
            <div className="space-y-3 sm:space-y-4">
              <p className="text-sm sm:text-base text-gray-700">
                Oavsett om ni är ett etablerat företag eller en startup hjälper vi er att skapa 
                kommunikation som sticker ut och driver er verksamhet framåt.
              </p>
              
              <h4 className="font-bold text-storystore-blue mt-4 sm:mt-6 text-sm sm:text-base">Vi hjälper företag med:</h4>
              <ul className="list-disc pl-5 space-y-1 sm:space-y-2 text-sm sm:text-base text-gray-700">
                <li>Varumärkesstrategi och positionering</li>
                <li>Reklamkampanjer för olika kanaler</li>
                <li>Innehållsproduktion för sociala medier</li>
                <li>Professionell film- och videoproduktion</li>
                <li>Digital marknadsföring och strategi</li>
              </ul>
              
              <p className="text-sm sm:text-base text-gray-700 italic mt-4 sm:mt-6">
                "Vi hjälper er att berätta er historia på ett sätt som engagerar målgruppen och 
                stärker ert varumärke i en digital värld."
              </p>
            </div>
            
            <div className="mt-6 sm:mt-8 text-center">
              <a href="#kontakt" className="btn-primary text-sm sm:text-base py-2 sm:py-3 px-4 sm:px-6">Kontakta oss för företag</a>
            </div>
          </div>
          
          {/* Influencers */}
          <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8 transform transition-all duration-300 hover:scale-105">
            <div className="bg-storystore-red/10 w-16 sm:w-20 h-16 sm:h-20 rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto">
              <Users size={isMobile ? 32 : 40} className="text-storystore-red" />
            </div>
            
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-center text-storystore-blue">Influencers</h3>
            
            <div className="space-y-3 sm:space-y-4">
              <p className="text-sm sm:text-base text-gray-700">
                För influencers och content creators erbjuder vi skräddarsydda lösningar som 
                hjälper dig att växa din plattform och skapa professionellt innehåll.
              </p>
              
              <h4 className="font-bold text-storystore-red mt-4 sm:mt-6 text-sm sm:text-base">Vi hjälper influencers med:</h4>
              <ul className="list-disc pl-5 space-y-1 sm:space-y-2 text-sm sm:text-base text-gray-700">
                <li>Innehållsstrategi för olika plattformar</li>
                <li>Professionell video- och fotoproduktion</li>
                <li>Personlig varumärkesutveckling</li>
                <li>Samarbeten med relevanta varumärken</li>
                <li>Kreativ rådgivning och konceptutveckling</li>
              </ul>
              
              <p className="text-sm sm:text-base text-gray-700 italic mt-4 sm:mt-6">
                "Vi hjälper dig att höja kvaliteten på ditt innehåll och bygga ett starkt 
                personligt varumärke som attraherar både följare och samarbetspartners."
              </p>
            </div>
            
            <div className="mt-6 sm:mt-8 text-center">
              <a href="#kontakt" className="btn-secondary text-sm sm:text-base py-2 sm:py-3 px-4 sm:px-6">Kontakta oss för influencers</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
